import { memo } from 'react';

import {
  PrivateGalleryBoard,
  type PrivateGalleryBoardProps,
} from '~/components/v2/components/board/gallery/PrivateGalleryBoard';
import { usePrivateBoardAncestorsString } from '~/components/v2/hooks/usePrivateBoardAncestorsString';
import { useIsSearchActive } from '~/hooks/search/useIsSearchActive';

export type PrivateBoardGalleryViewBoardProps = Omit<PrivateGalleryBoardProps, 'trackLocation' | 'ancestors'>;

export const PrivateBoardGalleryViewBoard = memo(({ box, data, index }: PrivateBoardGalleryViewBoardProps) => {
  const { isSearchActive } = useIsSearchActive();
  const { ancestorsString } = usePrivateBoardAncestorsString({
    ancestors: data.ancestors,
    library: data.library,
  });

  return (
    <PrivateGalleryBoard ancestors={isSearchActive ? ancestorsString : undefined} box={box} data={data} index={index} />
  );
});

PrivateBoardGalleryViewBoard.displayName = 'PrivateBoardGalleryViewBoard';
